import { render } from "./NewOurClients.vue?vue&type=template&id=a7ff986e"
import script from "./NewOurClients.vue?vue&type=script&lang=js"
export * from "./NewOurClients.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__